<div id="pw-data-card-container" class="prevent-select" [ngClass]="language">
    <div id="pw-data-card-header" [class]="headerClass" [ngClass]="{'half-height': isShowingCharts}">
        {{title}} <fa-icon *ngIf="headerIcon1" [icon]="headerIcon1"></fa-icon> <fa-icon *ngIf="headerIcon2" [icon]="headerIcon2"></fa-icon>
    </div>
    <div id="pw-data-card-body">
        {{value}}
    </div>
</div>
